import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ApplyForm from "./ApplyForm";

const DataAnalysis: React.FC = () => {
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="Career details" pagesub="Data Analysis Intern" />
                        <section className="career-details">
                            <div className="container">
                                <div className="cp-details-wrap">

                                    {/* Manager Info */}
                                    <div className="cp-manager_info">
                                        <h2 className="details-content-title mb-30">
                                            Data Analysis Intern – (Full-time / Internship)
                                        </h2>

                                        <ul className="xb-details-content list-unstyled mb-35">
                                            <li><span>Department :</span> Data & Analytics</li>
                                            <li><span>No. of Openings :</span> (3)</li>
                                            <li><span>Job Type :</span> Full-Time Internship</li>
                                            <li><span>Location :</span> Software Technology Park Chattogram, Level 6, Agrabad Circle, Chittagong, Bangladesh</li>
                                            <li><span>Working days : </span>6 days.</li>
                                            <li><span>Experience Required :</span> 0–1 Year (Fresh Graduates Encouraged)</li>
                                        </ul>

                                        <p className="mb-30">
                                            We’re looking for an enthusiastic Data Analysis Intern to join our growing analytics team. You will work with diverse datasets, support business decision-making, and collaborate with cross-functional teams. You should be eager to learn, comfortable working with data, and able to handle multiple tasks in a dynamic environment.
                                        </p>

                                        <p>
                                            Attention to detail, curiosity, and analytical thinking should come naturally to you. You will be mentored by experienced analysts, engineers, and product specialists while contributing to real, impactful projects.
                                        </p>
                                    </div>

                                    {/* What you'll do */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">What you'll get to do...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Clean, organize, and prepare raw data for analysis.</li>
                                            <li>Perform exploratory data analysis (EDA) to identify insights and trends.</li>
                                            <li>Support the team in building dashboards and business reports.</li>
                                            <li>Assist in creating predictive models and data visualizations.</li>
                                            <li>Work closely with data engineers, analysts, and product managers.</li>
                                            <li>Validate data accuracy and support quality checks.</li>
                                            <li>Present key findings to stakeholders through clear documentation.</li>
                                            <li>Continuously learn new tools, techniques, and industry best practices.</li>
                                        </ul>
                                    </div>

                                    {/* Experience section */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Your experience should include...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Basic understanding of data analytics and statistics.</li>
                                            <li>Strong logical and analytical thinking.</li>
                                            <li>Good command over spreadsheets (Excel/Google Sheets).</li>
                                            <li>Basic knowledge of SQL or database querying.</li>
                                            <li>Ability to communicate findings clearly.</li>
                                            <li>Understanding of business metrics and KPIs.</li>
                                            <li>Ability to work independently and within a team.</li>
                                            <li>High attention to detail and accuracy.</li>
                                        </ul>
                                    </div>

                                    {/* You might have */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">You might also have...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Experience with Python or R for data analysis.</li>
                                            <li>Familiarity with Power BI, Tableau, or Google Data Studio.</li>
                                            <li>Knowledge of machine learning fundamentals.</li>
                                            <li>Experience with Google Analytics or similar tools.</li>
                                            <li>Understanding of ETL concepts or data pipelines.</li>
                                            <li>Passion for data, analytics, and continuous improvement.</li>
                                        </ul>
                                    </div>

                                    {/* Benefits */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Great benefits...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Mentorship from senior analytics professionals.</li>
                                            <li>Hands-on experience with real business data.</li>
                                            <li>Opportunity for full-time placement based on performance.</li>
                                            <li>Friendly and collaborative work environment.</li>
                                            <li>Access to learning materials and training sessions.</li>
                                            <li>Flexible working hours.</li>
                                        </ul>
                                    </div>
                                    
                                    {/* ApplyForm */}
                                    <ApplyForm />

                                </div>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default DataAnalysis;
